module.exports = __webpack_public_path__ + "static/img/map.3f96228f.png";